import countries from './utils/countries';
import dates from './utils/dates'
import events from './utils/events';
import results from './utils/results';

export default {countries, dates, events, results};
